import { action } from '@ember/object';
import { cached } from '@glimmer/tracking';
import BaseFilterComponent from 'uplisting-frontend/components/ui/filters/filter/-base';

export interface ISelectAllFilter {
  options: unknown[];
  params: { selectedRecords?: unknown[] };
  reset(): void;
  selectAll(): void;
}

export default abstract class BaseMultiSelectFilterComponent<
  T extends ISelectAllFilter,
> extends BaseFilterComponent<T> {
  @cached
  get isAllSelected(): boolean {
    const { options, params } = this.filter;

    return (
      options.length > 0 &&
      (params.selectedRecords?.length ?? 0) === options.length
    );
  }

  @action
  handleToggleAll(): void {
    if (this.isAllSelected) {
      this.filter.reset();
    } else {
      this.filter.selectAll();
    }

    this.args.onFilterUpdate();
  }
}
